import styled from "styled-components";

export const ChannelGrid = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(auto-fill, minmax(175px, 2fr));
  grid-gap: 8px;
`;
